// Generic collapsed-by-default section — admin/CLAUDE.md's approval-screen
// brief: "Surface only what changes the decision... Everything else
// collapses." Used twice on ApprovalDetailPage (the full line list, and
// secondary request/total details) rather than writing the same toggle-
// button/chevron logic twice. Closed on every mount (plain useState, no
// persisted state), same discipline as PriceReference.jsx's "Other tiers"
// toggle this generalizes.

import { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext.jsx';
import styles from './Collapsible.module.css';

export default function Collapsible({ showLabelId, hideLabelId, showLabelVars, children }) {
  const { t } = useLanguage();
  const [open, setOpen] = useState(false);

  return (
    <div className={styles.wrapper}>
      <button
        type="button"
        className={styles.toggle}
        onClick={() => setOpen((prev) => !prev)}
        aria-expanded={open}
      >
        {open ? (
          <ChevronUp size={16} aria-hidden="true" />
        ) : (
          <ChevronDown size={16} aria-hidden="true" />
        )}
        {open ? t(hideLabelId) : t(showLabelId, showLabelVars)}
      </button>
      {open && <div className={styles.content}>{children}</div>}
    </div>
  );
}
